import React from "react";
import './pdfStyle.css';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
    render() {
        const data = (this.props.data).slice();
        const searchData = this.props.searchData;
        const subNames = this.props.contentRowNames;
        const summeryValues = this.props.summeryValues;
        const summeryData = this.props.summeryData;
        const summaryUnits = this.props.summaryUnits
        const selectedSearchValues = this.props.selectedSearchValues;
        const originalDataCount = data.slice()
        const chunkedData = this.chunkArray(data, 25);
        const chunkedTotalValues = this.calculateChunkTotals(data, 25, selectedSearchValues)
        const totalValues = this.props.totalValues;
        const newCol = ["Session 1", "Session 2", "Session 3", "Session 4"]
        const getOverKg = (row) => {
            const total = parseFloat(row.total);
            const maxValue = parseInt(row.maxValue);
            const minValue = parseInt(row.minValue);
            const isHolidayOrSunday = parseInt(row.isHolidayOrSunday);
            let overKg;
            let day;
            let isCashKilo = false;
            let manDay;

            if (isHolidayOrSunday == 1) {
                if (total >= maxValue) {
                    overKg = (total - maxValue).toFixed(2);
                    day = maxValue.toFixed(2);
                    manDay = 1.50;
                } else if (total < maxValue) {
                    overKg = Math.floor(total).toFixed(2);
                    day = 0.00;
                    manDay = 0.00;
                    //isCashKilo = true;
                }
            }
            else {
                if (total >= maxValue) {
                    overKg = (total - maxValue).toFixed(2);
                    day = maxValue.toFixed(2);
                    manDay = 1.00;
                } else if (total >= minValue && total <= maxValue) {
                    overKg = (0).toFixed(2);
                    day = total.toFixed(2);
                    manDay = 1.00;
                } else if (total <= minValue && total >= (maxValue / 2)) {
                    overKg = Math.floor(total - (maxValue / 2)).toFixed(2);
                    day = Math.ceil(maxValue / 2).toFixed(2);
                    isCashKilo = true;
                    manDay = 0.50;
                } else if (total < (maxValue / 2)) {
                    overKg = (total).toFixed(2);
                    day = (0).toFixed(2);
                    manDay = 0.00;
                } else {
                    overKg = (0).toFixed(2);
                    day = (0).toFixed(2);
                    manDay = 0.00;
                }
            }

            return { overKg, day, isCashKilo, manDay };
        };
        return (
            <div style={{ width: '100%', marginTop: -40 }}>
                {chunkedData.map((chunk, index) => (
                    <div className="pdf-head">
                        <h3 style={{ fontWeight: "bold" }}><center>{searchData.group}</center></h3>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div><b>Plucking Manual Checklist - TEA</b></div>
                            <div>
                                <b> {selectedSearchValues.checklistID}</b>
                            </div>
                            <div>
                                {selectedSearchValues.pluckingType === "RSM" ? "Outgrower" : selectedSearchValues.pluckingType}
                            </div>

                        </div>
                        <div className="pdf-root">
                            <table className="head-table">
                                <thead>
                                    <tr>
                                        <th colSpan={2}>Initial of Field Officer</th>
                                        <th></th>
                                        <th>Norm / Task</th>
                                        <th></th>
                                        <th>Date</th>
                                        <th>{selectedSearchValues.date}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Operation Entity</td>
                                        <td>{selectedSearchValues.operationEntity}</td>
                                        <td colSpan={5}>Name and Initial of Field Asst.</td>
                                    </tr>
                                    <tr>
                                        <td>Collection Point</td>
                                        <td>{selectedSearchValues.collectionPoint}</td>
                                        <td colSpan={3}>No. of Workers at Musters : {index == 0 ? originalDataCount.length : ''}</td>
                                        <td colSpan={2}>Muster Distributed by :(Sign)</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>Field Officer:</td>
                                        <td colSpan={3}>Supervisor</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="data-table" id="data-table">
                                <thead>
                                    <tr style={{ height: '30px' }}>
                                        <th style={{ width: '20px' }}></th>
                                        <th style={{ width: '50px' }}>E.P.F <br />No</th>
                                        <th style={{ width: '120px' }}>Name</th>
                                        <th style={{ width: '50px' }}>Field <br />No.</th>
                                        <th>1st <br />Wt.</th>
                                        <th>2nd <br />Wt.</th>
                                        <th>3rd <br />Wt.</th>
                                        <th>4th <br />Wt.</th>
                                        <th style={{ width: '50px' }}>Day</th>
                                        <th>OK / CK</th>
                                        <th style={{ width: '50px' }}>Man Day</th>
                                        <th style={{ width: '50px' }}>Borrowed <br /> Collection Point</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chunk.map((row, index) => {
                                        const { overKg, day, isCashKilo } = getOverKg(row);

                                        return (
                                            <tr style={isCashKilo && selectedSearchValues.pluckingType == 'GENERAL' ? { background: "#C8EDBE" } : {}}>
                                                <td style={{ width: '20px' }}>{index + 1}</td>
                                                <td style={{ width: '50px' }}>{row.registrationNumber}</td>
                                                <td style={{ width: '120px' }} className='table-name-col'>{row.firstName}
                                                    <br />
                                                    {row.assignAt ? <span style={{ color: 'green', fontSize: '8px' }}>
                                                        {`(${moment(row.assignAt).format("hh:mm a")})`}
                                                    </span> : !row.assignAt && row.registrationNumber ?
                                                        <span style={{ color: 'red', fontSize: '8px' }}>
                                                            {"(Not Assigned)"}
                                                        </span> :
                                                        <span style={{ fontSize: '11px' }}>
                                                            {""}
                                                        </span>
                                                    }
                                                </td>
                                                <td style={{ width: '50px' }} className="field-name-col">{row.fieldName}</td>
                                                {newCol.map((roww, index) => {
                                                    const found = row[roww];
                                                    const sessionTimeKey = `${roww} ReadTime`;
                                                    const sessionTime = row[sessionTimeKey];
                                                    return (
                                                        <td style={{ overflow: 'visible', align: 'right' }}>{found == undefined ? ' ' : parseFloat(found).toFixed(2)}
                                                            <br />
                                                            <span style={{ color: 'green', fontSize: '8px' }}>
                                                                {sessionTime ? `(${moment(sessionTime).format("hh:mm a")})` : ' '}
                                                            </span>
                                                        </td>
                                                    )
                                                })}
                                                {/* {subNames.length > 0 ? <td style={{ overflow: 'visible', align: 'right' }}>{row[subNames[0]] == undefined ? ' ' : parseFloat(row[subNames[0]]).toFixed(2)}</td> : <td style={{ overflow: 'visible' }}></td>}
                                                {subNames.length > 1 ? <td style={{ overflow: 'visible', align: 'right' }}>{row[subNames[1]] == undefined ? ' ' : parseFloat(row[subNames[1]]).toFixed(2)}</td> : <td style={{ overflow: 'visible' }}></td>}
                                                {subNames.length > 2 ? <td style={{ overflow: 'visible', align: 'right' }}>{row[subNames[2]] == undefined ? ' ' : parseFloat(row[subNames[2]]).toFixed(2)}</td> : <td style={{ overflow: 'visible' }}></td>}
                                                {subNames.length > 3 ? <td style={{ overflow: 'visible', align: 'right' }}>{row[subNames[3]] == undefined ? ' ' : parseFloat(row[subNames[3]]).toFixed(2)}</td> : <td style={{ overflow: 'visible' }}></td>} */}
                                                {searchData.pluckingType == 'GENERAL' && !row.empty ?
                                                    <td style={{ overflow: 'visible' }} align="center">
                                                        {getOverKg(row).day == 0 ? "0.00" : getOverKg(row).day}</td> :
                                                    <td style={{ overflow: 'visible' }} align="center"></td>}
                                                {searchData.pluckingType == 'GENERAL' && !row.empty ?
                                                    (row.total ? <td style={{ width: '50px' }}>{getOverKg(row).overKg}</td> : <td style={{ width: '50px' }}></td>) :
                                                    (row.total ? <td style={{ width: '50px' }}>{row.total.toFixed(2)}</td> : <td style={{ width: '50px' }}></td>)}
                                                {searchData.pluckingType == 'GENERAL' && !row.empty ?
                                                    (<td style={{ width: '50px', borderTop: '1px solid #000000' }}>{getOverKg(row).manDay == null ? '-' : getOverKg(row).manDay.toFixed(2)}</td>) :
                                                    (<td style={{ width: '50px', borderTop: '1px solid #000000' }}>{""}</td>)}
                                                <td style={{ width: '50px', borderTop: '1px solid #000000' }}>{row.borrowedDivision == null ? '-' : row.borrowedDivision}</td>
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td colSpan={2}></td>
                                        <td colSpan={2}><b>Total</b></td>
                                        <td>{(chunkedTotalValues[index].firstWeightTotal).toFixed(2)}</td>
                                        <td>{(chunkedTotalValues[index].secondWeightTotal).toFixed(2)}</td>
                                        <td>{(chunkedTotalValues[index].thirdWeightTotal).toFixed(2)}</td>
                                        <td>{(chunkedTotalValues[index].fourthWeightTotal).toFixed(2)}</td>
                                        <td>{selectedSearchValues.pluckingType == 'GENERAL' ? (totalValues.totalDay).toFixed(2) : (chunkedTotalValues[index].dayWeightTotal).toFixed(2)}</td>
                                        <td>{selectedSearchValues.pluckingType == 'GENERAL' ?
                                            (totalValues.totalOverKg).toFixed(2) : '0.00'}</td>
                                        <td>{selectedSearchValues.pluckingType == 'GENERAL' ?
                                            (summeryValues.totMandays).toFixed(2) : '0.00'}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="summary-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "48px" }}></th>
                                        <th style={{ width: "45px" }}>G. Leaf Wt.</th>
                                        <th style={{ width: "45px" }}>No. of Bags</th>
                                        <th style={{ width: "26px" }}></th>
                                        <th style={{ width: '300px' }} colSpan={7}>Checked by Supdt. / Asst. Supdt./ Field Officer</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "70px" }}>1st</td>
                                        <td style={{ width: "50px" }}>{chunkedData.length - 1 !== index ? '............' : summeryData.find(x => x.name == "Session 1")?.value.toFixed(2) ?? '..............'}</td>
                                        <td style={{ width: "50px" }}>{chunkedData.length - 1 !== index ? '............' : summaryUnits.find(x => x.name == "Session 1UN")?.value.toFixed(2) ?? '..............'}</td>
                                        <td style={{ width: "20px" }}></td>
                                        <td colSpan={2}>Plkrs at PM Check</td>
                                        <td colSpan={1}></td>
                                        <td colSpan={4}>Checked by :</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}>2nd</td>
                                        <td style={{ width: "50px" }}>{chunkedData.length - 1 !== index ? '............' : summeryData.find(x => x.name == "Session 2")?.value.toFixed(2) ?? '..............'}</td>
                                        <td style={{ width: "50px" }}>{chunkedData.length - 1 !== index ? '............' : summaryUnits.find(x => x.name == "Session 2UN")?.value.toFixed(2) ?? '..............'}</td>
                                        <td style={{ width: "20px" }}></td>
                                        <td colSpan={2}>Plkrs at AM Check</td>
                                        <td></td>
                                        <td colSpan={2}>Name & Designation</td>
                                        <td>Time</td>
                                        <td>Initial</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}>3rd</td>
                                        <td style={{ width: "50px" }}>{chunkedData.length - 1 !== index ? '............' : summeryData.find(x => x.name == "Session 3")?.value.toFixed(2) ?? '..............'}</td>
                                        <td style={{ width: "50px" }}>{chunkedData.length - 1 !== index ? '............' : summaryUnits.find(x => x.name == "Session 3UN")?.value.toFixed(2) ?? '..............'}</td>
                                        <td style={{ width: "20px" }}></td>
                                        <td colSpan={2}>No. of Kanganies A.M</td>
                                        <td></td>
                                        <td colSpan={2}></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}></td>
                                        <td style={{ width: "50px" }}>{chunkedData.length - 1 !== index ? '............' : summeryData.find(x => x.name == "Session 4")?.value.toFixed(2) ?? '..............'}</td>
                                        <td style={{ width: "50px" }}>{chunkedData.length - 1 !== index ? '............' : summaryUnits.find(x => x.name == "Session 4UN")?.value.toFixed(2) ?? '..............'}</td>
                                        <td style={{ width: "20px" }}></td>
                                        <td colSpan={2}>No. of Kanganies P.M</td>
                                        <td></td>
                                        <td colSpan={2}></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}><b>Total</b></td>
                                        <td style={{ width: "50px" }}>{chunkedData.length - 1 !== index ? '............' : summeryValues != undefined ? summeryValues.allTotal : '..............'}</td>
                                        <td style={{ width: "50px" }}>{chunkedData.length - 1 !== index ? '............' : summeryValues != undefined ? summeryValues.totalOfUnits : '..............'}</td>
                                        <td style={{ width: "20px" }}></td>
                                        <td colSpan={2}>No. of Sack Labrs</td>
                                        <td></td>
                                        <td colSpan={2}></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <center style={{ fontSize: '9px' }}>
                            <div className="row pb-0 pt-4">
                                <div className="col"> </div>
                                <div className="col"> </div>
                                <div className="col">Authorized by</div>
                                <div className="col">Checked by</div>
                                <div className="col">Approved by</div>
                            </div>
                            <div className="row pb-0 pt-3">
                                <div className="col">Weighing done by </div>
                                <div className="col">.............................. </div>
                                <div className="col">..............................</div>
                                <div className="col">.............................</div>
                                <div className="col">..............................</div>
                            </div>
                            <div className="row pb-0 pt-0">
                                <div className="col"> (Field) </div>
                                <div className="col"> </div>
                                <div className="col">Asst Supdt.</div>
                                <div className="col">Div.Clerk</div>
                                <div className="col">Supd</div>
                            </div>
                        </center>
                        {chunkedData.length - 1 !== index ? <div className='pagebreak'></div> : <div></div>}
                    </div>
                ))}
            </div>
        );
    }
    chunkArray(array, size) {
        let i = array.length % size == 0 ? 25 : array.length % size
        for (i; i < 25; i++) {
            array.push({ empty: true })
        }
        const chunkedArr = [];
        let index = 0;
        while (index < array.length) {
            chunkedArr.push(array.slice(index, size + index));
            index += size;
        }
        return chunkedArr;
    }

    calculateChunkTotals(array, size, selectedSearchValues) {
        const chunkedArr = [];
        let index = 0;
        while (index < array.length) {
            chunkedArr.push(array.slice(index, size + index));
            index += size;
        }
        let firstWeightTotal = 0
        let secondWeightTotal = 0
        let thirdWeightTotal = 0
        let fourthWeightTotal = 0
        let overKgWeight = 0
        let dayWeightTotal = 0
        let chunkedTotals = []
        let chuckTotalData = {}
        for (let i = 0; chunkedArr.length > i; i++) {
            for (let j = 0; j < chunkedArr[i].length; j++) {
                const currentItem = chunkedArr[i][j];
                firstWeightTotal += currentItem['Session 1'] == undefined ? 0 : currentItem['Session 1'];
                secondWeightTotal += currentItem['Session 2'] == undefined ? 0 : currentItem['Session 2'];
                thirdWeightTotal += currentItem['Session 3'] == undefined ? 0 : currentItem['Session 3'];
                fourthWeightTotal += currentItem['Session 4'] == undefined ? 0 : currentItem['Session 4'];

                if (selectedSearchValues.pluckingType == 'GENERAL') {
                    const total = parseFloat(currentItem.total);
                    const configValue = parseFloat(currentItem.configurationValue);
                    if (total > 0 && configValue > 0) {
                        const overWeight = total < configValue / 2 ? 0 :
                            (total - configValue) < 0 ? (total - configValue / 2).toFixed(2) :
                                (total - configValue).toFixed(2);
                        overKgWeight += parseFloat(overWeight);
                    }
                } else {
                    overKgWeight += 0;
                }
                dayWeightTotal += currentItem.total == undefined ? 0 : currentItem.total;
            }
            chuckTotalData = {
                firstWeightTotal,
                secondWeightTotal,
                thirdWeightTotal,
                fourthWeightTotal,
                overKgWeight,
                dayWeightTotal
            }
            chunkedTotals.push(chuckTotalData)
            firstWeightTotal = 0
            secondWeightTotal = 0
            thirdWeightTotal = 0
            fourthWeightTotal = 0
            overKgWeight = 0
            dayWeightTotal = 0
        }
        return chunkedTotals
    }
}
